(function() {
  'use strict';

  let requested = false;

  const highlightTopic = (sections, navLinks, className) => {
    const firstSection = sections.find((section) =>
      section.getBoundingClientRect().top < 30
    ) || sections[sections.length - 1];

    navLinks.forEach((link) => {
      if (link.hash === `#${firstSection.id}`) {
        link.classList.add(className);
      } else {
        link.classList.remove(className);
      }
    });
  }

  const wrapAnimationFrame = (fn) => {
    if (!requested) {
      requested = true;

      window.requestAnimationFrame(() => {
        requested = false;
        fn();
      });
    }
  }

  let handler;

  window.highlightScroll = (navLinkSelector, sectionSelector, className='selected') => {
    const navLinks = Array.from(document.querySelectorAll(navLinkSelector));
    const sections = Array.from(document.querySelectorAll(sectionSelector)).reverse();
    const fn = highlightTopic.bind(null, sections, navLinks, className);

    if (handler) {
      // Remove old listener, if exists
      window.removeEventListener('scroll', handler);
    }

    handler = (event) => {
      wrapAnimationFrame(fn);
    }

    window.addEventListener('scroll', handler);

    handler();
  }
})();